import axios from "axios";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";
import { setSelectedPortfolioExchange } from "../exchange/actions";

const initialState = {
  targetExchange: null,
  targetPortfolio: [],
  targetPortfolioStatus: "",
  step: 1,
  orderStatus: "",
  orderResponse: {},
  orderErrorMessage: "",
};

export const minimalTradeSlice = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case "set-target-exchange":
      return {
        ...state,
        targetExchange: payload,
      };
    case "request-get-target-portfolio":
      return {
        ...state,
        targetPortfolio: [],
        targetPortfolioStatus: "loading",
      };
    case "fetch-get-target-portfolio":
      return {
        ...state,
        targetPortfolio: payload?.portfolio,
        targetPortfolioStatus: "success",
      };

    case "failed-get-target-portfolio":
      return {
        ...state,
        targetPortfolio: [],
        targetPortfolioStatus: "error",
      };
    case "canceled-get-target-portfolio":
      return {
        ...state,
        targetPortfolioStatus: "loading",
        targetPortfolio: [],
      };

    case "place-order-request":
      return {
        ...state,
        orderStatus: "loading",
        orderResponse: {},
        orderErrorMessage: "",
        step: 2,
      };
    case "place-order-success":
      return {
        ...state,
        orderStatus: "success",
        orderResponse: payload,
      };
    case "place-order-error":
      return {
        ...state,
        orderStatus: "error",
        orderErrorMessage: payload,
      };

    case "clear-form-state":
      return initialState;

    default:
      return state;
  }
};

export const resetFormState = () => (dispatch) => {
  return dispatch({ type: "clear-form-state" });
};

export const setTargetExchange = (targetExchange) => (dispatch) => {
  return dispatch({ type: "set-target-exchange", payload: targetExchange });
};

export const getTargetExchangePortfolio =
  (
    user,
    email,
    exchange_id,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "request-get-target-portfolio" });

    const url =
      "https://ydq39f2t8b.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      mode: "get_portfolio",
      user,
      email,
      exchange_id,
    };

    if (retryCount > 0) {
      data.use_more_caching = "True";
    }

    await axios
      .post(url, data, { signal })
      .then((res) => {
        dispatch({
          type: "fetch-get-target-portfolio",
          payload: res.data,
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          dispatch({ type: "canceled-get-target-portfolio" });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              getTargetExchangePortfolio(
                user,
                email,
                exchange_id,
                signal,
                retryCount + 1,
              ),
            "failed-get-target-portfolio",
            user,
            email,
            formatTelegramLog("get_portfolio", data, url),
            0,
            currentPath,
          );
        }
      });
  };

export const quickPlaceOrder =
  (
    user,
    email,
    trade_type,
    exchange_id,
    asset,
    amount,
    trigger_price,
    trigger_price2 = "",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "place-order-request" });

    const formattedAsset =
      exchange_id === "swyftx"
        ? asset?.split("/USDT")?.[0]
        : asset?.includes("/USDT")
          ? asset
          : asset + "/USDT";

    const data = {
      mode: "order_trade",
      exchange_id,
      user,
      email,
      asset: formattedAsset,
      trade_type,
      freeze_limit_order: "True",
      amount: `${amount}`,
      trigger_price: `${trigger_price * 100}`,
      currency: exchange_id === "swyftx" ? "USDT" : "",
    };

    if (trade_type === "buy" || trade_type === "sell") {
      data.trigger_price = "";
    }

    if (trade_type === "buy_with_oco") {
      data.trigger_price2 = `${trigger_price2 * 100}`;
      data.amount_usdt = `${amount}`;
      delete data.amount;
    }

    const url =
      "https://ydq39f2t8b.execute-api.ap-southeast-2.amazonaws.com/dev/api";

    await axios
      .post(url, data)
      .then((res) => {
        // console.log(res?.data);
        dispatch({ type: "place-order-success", payload: res?.data });
        dispatch(setSelectedPortfolioExchange(exchange_id, user, email));
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            quickPlaceOrder(
              user,
              email,
              trade_type,
              exchange_id,
              asset,
              amount,
              trigger_price,
              (trigger_price2 = ""),
              retryCount + 1,
            ),
          "place-order-error",
          user,
          email,
          formatTelegramLog("place-order", data, url),
          0,
          currentPath,
        );
      });
  };
